export default __webpack_public_path__ + "static/media/component_template.dcdef0e5.xlsx";